import { SERVICES }                         from '@shared/constants/apiConfig';
import { ECheckType }                       from '@shared/interfaces';
import { CheckRequestAPI }                  from './requests';
import { ECheckRequest, ICheckStatus } from './interfaces';

export const apiPrefix = `/${SERVICES.ACCOUNTING}/checkrequest`;

export enum EButtonAction {
  Cut     = 'cut',
  Decline = 'decline',
  Declined = 'declined',
  Undo    = 'undo',
  Submit  = 'submit'
}

export const checkStatus: ICheckStatus = {
  [ECheckType.Cut]: {
    status           : 'CHECK_CUT',
    fn               : CheckRequestAPI.PATCH,
    apiURL           : `${apiPrefix}`,
    checkRequestType : ECheckRequest.Check
  },
  [ECheckType.Void]: {
    status           : 'VOIDED_CHECK',
    fn               : CheckRequestAPI.PATCH,
    apiURL           : `${apiPrefix}`,
    checkRequestType : ECheckRequest.Check
  },
  [ECheckType.Sent]: {
    status           : 'CHECK_SENT',
    fn               : CheckRequestAPI.PATCH,
    apiURL           : `${apiPrefix}`,
    checkRequestType : ECheckRequest.Check
  },
  [ECheckType.Requests]: {
    status           : 'CHECK_REQUEST',
    fn               : CheckRequestAPI.PATCH,
    apiURL           : `${apiPrefix}`,
    checkRequestType : ECheckRequest.Check
  },
  [ECheckType.Declined]: {
    status           : 'CHECK_REQUEST_DECLINED',
    fn               : CheckRequestAPI.PATCH,
    apiURL           : `${apiPrefix}`,
    checkRequestType : ECheckRequest.Check
  },
  [ECheckType.Undo]: {
    status           : 'CHECK_UNDO',
    apiURL           : `${apiPrefix}/undo`,
    fn               : CheckRequestAPI.POST,
    checkRequestType : ECheckRequest.Check
  },
  [ECheckType.ATRefundCheck]: {
    status           : 'AT_REFUND_CHECK',
    apiURL           : `${apiPrefix}`,
    fn               : CheckRequestAPI.PATCH,
    checkRequestType : ECheckRequest.AtRefundCheck
  },
  [ECheckType.ProductRequestsCut]: {
    status           : 'PRODUCT_CHECK_REQUEST_CUT',
    apiURL           : `${apiPrefix}`,
    fn               : CheckRequestAPI.PATCH,
    checkRequestType : ECheckRequest.Product
  },
  [ECheckType.ProductRequestsDeclined]: {
    status           : 'PRODUCT_CHECK_REQUEST_DECLINED',
    apiURL           : `${apiPrefix}`,
    fn               : CheckRequestAPI.PATCH,
    checkRequestType : ECheckRequest.Product
  },
  [ECheckType.ProductRequests]: {
    status           : 'PRODUCT_CHECK_REQUEST',
    apiURL           : `${apiPrefix}`,
    fn               : CheckRequestAPI.PATCH,
    checkRequestType : ECheckRequest.Product
  }
};
